import { Link, NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import IngestProgressBanner from './IngestProgressBanner';
import LastUpdated from './LastUpdated';
import LivePulse from './LivePulse';

function navClass({ isActive }: { isActive: boolean }) {
  return `text-sm font-medium transition hover:text-[var(--primary)] ${
    isActive ? 'text-[var(--primary)]' : 'text-[var(--muted)]'
  }`;
}

export default function Layout() {
  return (
    <div className="min-h-screen bg-[var(--bg)] text-[var(--fg)]">
      <header className="sticky top-0 z-30 border-b border-[var(--border)] bg-[var(--card)]/90 backdrop-blur">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
          <Link to="/" className="text-xl font-bold text-[var(--primary)]">
            MixerLead Data
          </Link>
          <div className="flex items-center gap-3 sm:gap-4">
            <LivePulse />
            <span className="hidden h-4 w-px bg-[var(--border)] sm:inline" />
            <LastUpdated />
          </div>
          <nav className="flex items-center gap-6">
            <NavLink to="/" end className={navClass}>
              Dashboard
            </NavLink>
            <NavLink to="/records" className={navClass}>
              Records
            </NavLink>
            <NavLink to="/ingest" className={navClass}>
              Ingest
            </NavLink>
          </nav>
          <UserMenu />
        </div>
      </header>
      <IngestProgressBanner />
      <main className="mx-auto max-w-7xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}

function UserMenu() {
  const { user, logout, isLoading } = useAuth();

  const handleLogout = async () => {
    await logout();
    window.location.href = '/login';
  };

  return (
    <div className="flex items-center gap-3 text-sm">
      <span className="inline-flex items-center gap-1.5 rounded-full border border-[var(--border)] bg-[var(--bg)] px-3 py-1 text-[var(--muted)]">
        <span className="h-1.5 w-1.5 rounded-full bg-[var(--success)]" />
        {isLoading ? '…' : user?.username ?? 'Authenticated'}
      </span>
      <button
        onClick={handleLogout}
        className="font-medium text-[var(--muted)] transition hover:text-[var(--danger)]"
      >
        Log out
      </button>
    </div>
  );
}
